import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GuideLinkButton } from '../../../theme/components/GuideButtons';
import { RejectionRow } from '../../../functions/ProviderConsumptions.Functions';

/** Filas visibles antes de "Ver todos". */
export const REJECTED_VISIBLE = 10;

export interface ToSettleRejectedListProps {
  /** Rechazos recibidos (hasta 200 por respuesta) con servicio y fecha del ítem si está en la página. */
  rows: RejectionRow[];
  /** `rejectedTotal`: si supera lo recibido se muestra "y X más". */
  total: number;
}

/**
 * Detalle de los consumos que el PATCH to-settle no procesó (spec 010, US1): "servicio · fecha · mensaje",
 * 10 visibles + "Ver todos" y "y X más" con `rejectedTotal`. El mensaje del servidor va como texto.
 */
export const ToSettleRejectedList = ({ rows, total }: ToSettleRejectedListProps) => {
  const { t } = useTranslation();
  const tr = (path: string, options?: Record<string, unknown>) => t(`providerConsumptions.toSettle.result.${path}`, options);
  const [expanded, setExpanded] = useState(false);
  if (rows.length === 0 && total <= 0) return null;
  const visible = expanded ? rows : rows.slice(0, REJECTED_VISIBLE);
  const more = Math.max(0, total - rows.length);

  return (
    <div className="pcs-rejected" data-testid="pcs-to-settle-rejected">
      <ul className="pci-list pcs-rejected__list" aria-label={tr('rejectedLabel')}>
        {visible.map((row) => (
          <li key={row.id} data-testid={`pcs-to-settle-rejected-${row.id}`}>
            {[row.service, row.date, row.message].filter(Boolean).join(' · ')}
          </li>
        ))}
      </ul>
      {rows.length > REJECTED_VISIBLE && (
        <GuideLinkButton size="small" aria-expanded={expanded} onClick={() => setExpanded(!expanded)} data-testid="pcs-to-settle-rejected-toggle">
          {expanded ? tr('showLess') : tr('showAll', { count: rows.length })}
        </GuideLinkButton>
      )}
      {more > 0 && (
        <span className="pcs-secondary" data-testid="pcs-to-settle-rejected-more">
          {tr('rejectedMore', { count: more })}
        </span>
      )}
    </div>
  );
};

export default ToSettleRejectedList;
